import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import BookAppoiment from "../pages/BookAppoiment";

function AppRoutes() {
  let block = sessionStorage.getItem("blockPage");
  return (
    <Router>
      <Routes>
        <Route
          path={`/`}
          element={<BookAppoiment />}
        />
      </Routes>
    </Router>
  );
}

export default AppRoutes;
